module.exports = __webpack_public_path__ + "img/s8Bg8.a8130de7.jpg";